import TreeContent from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/tree_content.vue?vue3';
import preloadMixin from '../mixins/preload';
import repositoryPathMixin from '../mixins/repository_path';
import { updateElementsVisibility } from '../utils/dom';
export default {
    name: 'RepositoryTree',
    components: {
        TreeContent
    },
    mixins: [
        preloadMixin,
        repositoryPathMixin
    ],
    provide () {
        return {
            refType: this.refType
        };
    },
    props: {
        refType: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        isRoot () {
            return this.computedPath === '/';
        }
    },
    watch: {
        isRoot: {
            immediate: true,
            handler: 'updateElements'
        }
    },
    methods: {
        updateElements (isRoot) {
            updateElementsVisibility('.js-show-on-root', isRoot);
            updateElementsVisibility('.js-hide-on-root', !isRoot);
        }
    }
};
